export default {
    sectionTitle: 'px-30 md:px-0 block w-full font-bold text-[26px] md:text-[56px] text-left md:text-center collection-carousel mb-30 pt-40',
    subTitle: 'text-[13px] md:text-[19px] px-30 md:px-0 max-w-[975px] mx-auto text-left md:text-center mb-40',
    carouselTop: 'max-w-[1000px] px-30 md:px-0 mx-auto jamieCarousel mb-50',
    carouselTopImage: '',
    disclaimer: 'max-w-[1028px] px-30 md:px-0 mx-auto text-[8px] md:text-[15px] font-light pb-60',
    cardBorder: 'p-0 w-full flex col item-center border-2 rounded-[6px] border-transparent cardBorder',
    card: 'w-full bg-[#EED8A8] p-[15px] rounded-[6px]',    
    mediaWrap: 'w-full flex justify-center item-center bg-white bg-opacity-35 h-[295px] rounded-[6px]',
    media: 'w-full h-full object-contain md:object-scale-down p-10',
    mediaPlaceholder: 'w-full h-full object-none p-10',
    content: 'w-full px-[6px] pt-[8px]',
    type: 'text-[11px] text-[#525252] mb-10 capitalize',
    title: 'text-[14px] text-black mb-15 capitalize font-bold h-[35px] jamieHeading',
    cta: 'text-[14px] font-bold text-[#5B360C] underline',
};